import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as reducers from '../../store/reducers';

import Form from 'Components/Form';

class ResetPasswordForm extends React.PureComponent {
  render() {
    const { resetPasswordToken, user } = this.props;
    return (
      <Form
        type="resetPassword"
        id="resetPassword"
        submitArgs={{ resetPasswordToken, id: user.id }}
        formStyle="login"
        messagePosition="page-top"
        submitButtonType="primary"
      />
    );
  }
}

const mapStateToProps = (state, { match: { params } }) => {
  return {
    user: reducers.getResetPasswordUser(state),
    resetPasswordToken: decodeURIComponent(params.resetPasswordToken),
  };
};

export default withRouter(connect(mapStateToProps, {})(ResetPasswordForm));
